import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { RELEASE_NOTES, VERSION_LABEL } from "@/lib/version";

export default function ReleaseNotes() {
  return (
    <div className="fade-up" data-testid="release-notes-page">
      <div className="no-print flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#B38F4E]">
            WHAT&apos;S NEW
          </p>
          <h1 className="mt-2 text-3xl font-bold sm:text-4xl">Release notes</h1>
          <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
            You are running <span className="font-semibold">{VERSION_LABEL}</span>. Newest changes
            first — quote the version number if you need to report anything.
          </p>
        </div>
        <Link
          to="/guide"
          className="flex h-11 items-center gap-2 border border-[#C5A059] px-6 text-sm font-semibold transition-colors duration-150 hover:bg-[#FBF8F2]"
          data-testid="release-notes-guide-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back to handbook
        </Link>
      </div>

      <div className="mt-8 space-y-6">
        {RELEASE_NOTES.map((r, i) => (
          <section
            key={r.version}
            className="border border-border p-5"
            data-testid={`release-${r.version}`}
          >
            <div className="flex flex-wrap items-center gap-3">
              <h2 className="text-lg font-bold">v{r.version}</h2>
              {i === 0 && (
                <span className="bg-[#C5A059] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
                  Current
                </span>
              )}
              <span className="text-xs uppercase tracking-wider text-muted-foreground">
                {r.date}
              </span>
            </div>
            <ul className="mt-4 space-y-2">
              {(r.changes || r.notes || []).map((c) => (
                <li key={c} className="flex gap-2.5 text-sm">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 bg-[#C5A059]" />
                  <span>{c}</span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
